export default class Prevention {
  constructor({
    title,
    chapo_info_sheet: description,
    view_node: url,
    lien: lienExt,
    date_info_sheet: sheetPublicationDate,
    suggested_by: suggestedBy,
    date_dossier_thematic: folderPublicationDate,
    image_dossier_thematic: folderImage,
    region,
  }) {
    this.title = title;
    this.description = description;
    this.url = url;
    this.lienExt = lienExt;
    this.sheetPublicationDate = sheetPublicationDate;
    this.suggestedBy = suggestedBy;
    this.folderPublicationDate = folderPublicationDate;
    this.folderImage = folderImage;
    this.region = region;
    this.globalRegion = 'aucune région';
    this.buttonLabel = 'Lire l\'article';
    this.externalLink = false;
    if (this.lienExt) {
      this.url = this.lienExt;
      this.externalLink = true;
      this.lienExt = '';
    }
  }

  getSuggestedBy() {
    return this.suggestedBy;
  }

  getPublicationDate() {
    return this.sheetPublicationDate || this.folderPublicationDate;
  }

  getRegion() {
    return this.region;
  }

  getTitle() {
    return this.title;
  }

  getDescription() {
    return this.description?.length > 83
      ? `${this.description.slice(0, 83)}...` : this.description;
  }

  getUrl() {
    return this.url;
  }

  isExternalLink() {
    return this.externalLink;
  }

  isFolderType() {
    return !!this.folderPublicationDate;
  }

  getFolderImage() {
    if (this.folderImage) {
      const indexImageBegining = this.folderImage.indexOf('src="');
      const firsthalf = this.folderImage.slice(indexImageBegining + 5);
      const indexImageendig = firsthalf.indexOf('"');
      return firsthalf.slice(0, indexImageendig);
    }
    return '';
  }

  getButtonLabel() {
    return this.buttonLabel;
  }
}
